import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// Register all AG Grid community modules
ModuleRegistry.registerModules([AllCommunityModule]);
import { DataTablesModule } from 'angular-datatables';
import { BnNgIdleService } from 'bn-ng-idle';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseChartDirective } from 'ng2-charts';
import { allIcons, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccessmanagementModule } from './component/accessmanagement/accessmanagement.module';
import { ComponentComponent } from './component/component.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { EnitModule } from './component/enit/enit.module';
import { AnnualReturnModule } from './component/enit/EnitCompliance/Annual Returns/annual-return.module';
import { AuthorisedPersonAdminModule } from './component/enit/EnitCompliance/authorised-person/admin/authorised-person-admin.module';
import { AuthorisePersonMemberModule } from './component/enit/EnitCompliance/authorised-person/member/authorised-person-member.module';
import { CyberAuditModule } from './component/enit/EnitCompliance/CyberAudit/cyber-audit.module';
import { InternalAuditModule } from './component/enit/EnitCompliance/InternalAudit/internal-audit.module';
import { AutomationModule } from './component/enit/EnitTrade/Automation/automation.module';
import { ColoModule } from './component/enit/EnitTrade/Colo/colo.module';
import { CtclModule } from './component/enit/EnitTrade/ctcl/ctcl.module';
import { DualModule } from './component/enit/EnitTrade/Dual Locking/dual.module';
import { IpSurrenderModule } from './component/enit/EnitTrade/ip-surrender/ip-surrender.module';
import { LesModule } from './component/enit/EnitTrade/LES/les.module';
import { MultiLockingModule } from './component/enit/EnitTrade/multiple-locking-removal/multi-locking.module';
import { NnfModule } from './component/enit/EnitTrade/NNF/nnf.module';
import { ProEnablementModule } from './component/enit/EnitTrade/pro-enablement/pro-enablement.module';
import { WorkPremitModule } from './component/enit/EnitTrade/work-permit-module/work-permit.module';
import { MenumanagementModule } from './component/menumanagement/menumanagement.module';
import { RolemanagementModule } from './component/rolemanagement/rolemanagement.module';
import { ShortformComponent } from './component/shortform/shortform.component';
import { UsermanagementModule } from './component/usermanagement/usermanagement.module';
import { HeaderComponent } from './header/header.component';
import { LoggingInterceptor } from './interceptor/logging.interceptor';
import { LoginModule } from './login/login.module';
import { AppService } from './service/app.service';
import { ConfigService } from './service/config.service';
import { LoginService } from './service/login.service';
import { UtilityService } from './service/utility.service';
import { SidebarComponent } from './sidebar/sidebar.component';

@NgModule({
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports:[
    NgxSpinnerModule,
  ]
  ,
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    ComponentComponent,
    DashboardComponent,
    ShortformComponent,
  ],
  imports: [
    // NgbModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BaseChartDirective,
    HighchartsChartModule,
    DataTablesModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    LoginModule,
    HttpClientModule,
    UsermanagementModule,
    MenumanagementModule,
    RolemanagementModule,
    AccessmanagementModule,
    EnitModule,
    AutomationModule,
    ColoModule,
    CtclModule,
    DualModule,
    IpSurrenderModule,
    LesModule,
    InternalAuditModule,
    MultiLockingModule,
    NnfModule,
    ProEnablementModule,
    WorkPremitModule,
    AuthorisePersonMemberModule,
    AuthorisedPersonAdminModule,
    AgGridModule,
    BsDatepickerModule.forRoot(),
    NgxBootstrapIconsModule.pick(allIcons),
    SharedModule,
    NgxSpinnerModule,
    CyberAuditModule,
    RouterModule,
    TimepickerModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 5000,
      extendedTimeOut: 3000,
      positionClass: 'toast-top-right',
      progressBar: true,
      progressAnimation: 'decreasing',
      closeButton: true,
    })
  ],
  providers: [
    BsDatepickerConfig,
    AppService,
    ConfigService,
    LoginService,
    UtilityService,
    DatePipe,
    BnNgIdleService,
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
